import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOrderLineOther } from '../sale-order-line-other';
import { parseNumber } from '../../utils/number.utils';

export class SaleOrderLineOtherBuilder {

  static fromJson(json): SaleOrderLineOther {
    return (json) ? new SaleOrderLineOther(
      json.hash,
      json.concept,
      parseNumber(json.amount)
    ) : null;
  }

  static fromJsonList(list): SaleOrderLineOther[] {
    return (isArray(list)) ? sortByNumber('amount', mapCollection(SaleOrderLineOtherBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-line-other-builder.ts